import { useFile } from "../../../hooks/useFile";
import { getFileIcon } from "../../../utils";

const FileItem = ({ file }) => {
  const { downloadFile } = useFile();

  return (
    <div
      className="cursor-pointer text-gray-dark flex items-center gap-2"
      onClick={() => downloadFile(file)}
    >
      {getFileIcon(file.fileName)}
      <p
        className="text-sm text-gray-dark font-medium overflow-hidden text-ellipsis line-clamp-1"
        style={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          wordBreak: "break-all",
        }}
      >
        {file.fileName}
      </p>
    </div>
  );
};

export default FileItem;
